/*=========================================================================================
  File Name: state.js
  Description: App State
  ----------------------------------------------------------------------------------------
  Item Name: Fujisushi Web app
  Author: Tan Tran
==========================================================================================*/

export default {
  selectedRestaurant: '',
  isRestaurantSelected: false,
  isFavouriteSelected: false,
  networkError: false
}
